/*
** jhvids-builder.js
**
** Script for the jhVids Builder app
*/

import { directoryOpen, supported } from 'browser-fs-access';

const jhVidsBuilderVersion = '0.2.2';

// Initialization
let configFileData = '';
let configFound = false;
let introMusic = null;
let outroMusic = null;
let audio = null;
let context = 'fade-from-black';
let slideIndex = 0;
let firstSlideTimer = null;
let nextSlideTimer = null;
let presentationFolderName = '';
let presentationTitle;
let presentationCategory;
let presentationDate;
let presentationTitleImageBlob;
let musicApproach;
let backgroundMusicBlob;
let backgroundMusicVolume;
let introMusicBlob;
let introMusicVolume;
let outroMusicBlob;
let outroMusicVolume;
let introSeconds;
let outroSeconds;
let fadeFromBlackSeconds;
let fadeToBlackSeconds;
let slideshowLength = 0;
let slideAudioBlobs = [];
let slideImageBlobs = [];
let currentlyPlaying = false;

/*
** Initialize the presentation details
*/
function initPresentationDetails() {
    const detailsEl = document.getElementById('presentation-details');
    while (detailsEl.firstChild) {
        detailsEl.removeChild(detailsEl.firstChild);
    }
}

/*
** Close the current config file and return to initial state
*/
function closeConfig() {
    configFound = false;
    configFileData = '';
    presentationTitle = '';
    presentationCategory = '';
    presentationDate = '';
    presentationTitleImageBlob = null;
    slideAudioBlobs = [];
    slideImageBlobs = [];
    
    initPresentationDetails();

    //document.getElementById('config-error').classList.add('hidden');
    document.getElementById('openConfigButton').classList.remove('hidden');
    document.getElementById('startShowButton').classList.add('hidden');
    document.getElementById('closeConfigButton').classList.add('hidden');
}

/*
** Process the slideshow data read from config file
*/
function processSlideshowData() {
    try {
        const config = JSON.parse(configFileData);
        document.querySelectorAll('.presentation-details').forEach(el => el.classList.remove('hidden'))
        //document.querySelectorAll('.config-error').forEach(el => el.classList.add('hidden'))

        // Retrieve data from the config file
        presentationTitle = config.title || 'Title';
        presentationCategory = config.category || 'Category';
        presentationDate = config.date || Date.now();
        musicApproach = config.musicApproach;
        if (musicApproach !== 'background' && musicApproach !== 'intro-outro') {
            console.error('Unknown musicApproach "' + musicApproach + '" converted to "intro-outro"');
            musicApproach = 'intro-outro';
        }
        backgroundMusicVolume = config.backgroundMusicVolume || 0;
        introMusicVolume = config.introMusicVolume || 0;
        outroMusicVolume = config.outroMusicVolume || 0;
        introSeconds = config.introSeconds || 11;
        outroSeconds = config.outroSeconds || 4;
        fadeFromBlackSeconds = config.fadeFromBlackSeconds || 3;
        fadeToBlackSeconds = config.fadeToBlackSeconds || 3;

        // Set up the title slide to reflect the config data
        const imageEl = document.querySelector('.title-slide-image');
        imageEl.src = URL.createObjectURL(presentationTitleImageBlob);

        const categoryEl = document.querySelector('.title-slide-category');
        categoryEl.innerHTML = presentationCategory;

        const titleEl = document.querySelector('.title-slide-title');
        titleEl.innerHTML = presentationTitle;

        const dateEl = document.querySelector('.title-slide-date');
        dateEl.innerHTML = presentationDate;

        initPresentationDetails();

        let trEl, tdEl, separatorEl;
        const detailsEl = document.getElementById('presentation-details');

        // Folder
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Folder:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = presentationFolderName;
        trEl.appendChild(tdEl);

        // Title
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Title:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = presentationTitle;
        trEl.appendChild(tdEl);

        // Category
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Category:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = presentationCategory;
        trEl.appendChild(tdEl);

        // Date
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Date:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = presentationDate;
        trEl.appendChild(tdEl);

        // Title Image
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Title image:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        trEl.appendChild(tdEl);
        let imgEl = document.createElement('img');
        imgEl.id = 'title-image';
        imgEl.src = URL.createObjectURL(presentationTitleImageBlob);
        tdEl.appendChild(imgEl);

        // Music Approach
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Music approach:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = musicApproach;
        trEl.appendChild(tdEl);

        if (musicApproach === 'background') {
            // Background Music Path
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Background music clip:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            trEl.appendChild(tdEl);
            let backgroundMusicLink = document.createElement('a');
            backgroundMusicLink.href = URL.createObjectURL(backgroundMusicBlob);
            backgroundMusicLink.target = '_blank';
            backgroundMusicLink.classList.add('detail-link');
            backgroundMusicLink.innerHTML = backgroundMusicBlob.name;
            tdEl.appendChild(backgroundMusicLink);

            // Background Music Volume
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Background music volume:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            tdEl.innerHTML = backgroundMusicVolume + ' (' + (backgroundMusicVolume * 100) + '%)';
            trEl.appendChild(tdEl);
        } else {
            // Intro Music Path
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Intro music clip:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            trEl.appendChild(tdEl);
            let introMusicLink = document.createElement('a');
            introMusicLink.href = URL.createObjectURL(introMusicBlob);
            introMusicLink.target = '_blank';
            introMusicLink.classList.add('detail-link');
            introMusicLink.innerHTML = introMusicBlob.name;
            tdEl.appendChild(introMusicLink);

            // Intro Music Volume
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Intro music volume:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            tdEl.innerHTML = introMusicVolume + ' (' + (introMusicVolume * 100) + '%)';
            trEl.appendChild(tdEl);

            // Outro Music Path
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Outro music clip:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            trEl.appendChild(tdEl);
            let outroMusicLink = document.createElement('a');
            outroMusicLink.href = URL.createObjectURL(outroMusicBlob);
            outroMusicLink.target = '_blank';
            outroMusicLink.classList.add('detail-link');
            outroMusicLink.innerHTML = outroMusicBlob.name;
            tdEl.appendChild(outroMusicLink);

            // Outro Music Volume
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Outro music volume:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            tdEl.innerHTML = outroMusicVolume + ' (' + (outroMusicVolume * 100) + '%)';
            trEl.appendChild(tdEl);
        }

        // Intro Seconds
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Intro seconds:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = introSeconds;
        trEl.appendChild(tdEl);

        // Outro Seconds
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Outro seconds:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = outroSeconds;
        trEl.appendChild(tdEl);

        // Fade from black Seconds
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Fade from black seconds:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = fadeFromBlackSeconds;
        trEl.appendChild(tdEl);

        // Fade to black Seconds
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Fade to black seconds:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = fadeToBlackSeconds;
        trEl.appendChild(tdEl);

        // Calculate number of slides and ensure that a slot is present for
        // each slide's audio clip and background image
        slideshowLength = Math.min(slideAudioBlobs.length, slideImageBlobs.length);
        while (slideAudioBlobs.length < slideshowLength) {
            slideAudioBlobs.push(null);
        }
        while (slideImageBlobs.length < slideshowLength) {
            slideImageBlobs.push(null);
        }

        // Number of Slides
        trEl = document.createElement('tr');
        detailsEl.appendChild(trEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-label');
        tdEl.innerHTML = 'Number of slides:';
        trEl.appendChild(tdEl);
        tdEl = document.createElement('td');
        tdEl.classList.add('detail-value');
        tdEl.innerHTML = slideshowLength;
        trEl.appendChild(tdEl);

        for (let i = 0; i < slideshowLength; i++) {
            // Separator
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.colSpan = 2;
            trEl.appendChild(tdEl);
            separatorEl = document.createElement('div');
            separatorEl.classList.add('detail-separator');
            tdEl.appendChild(separatorEl);

            // Slide image
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Slide ' + (i + 1) + ' image:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            trEl.appendChild(tdEl);
            let imgEl = document.createElement('img');
            imgEl.id = 'slide-image';
            imgEl.src = URL.createObjectURL(slideImageBlobs[i]);
            tdEl.appendChild(imgEl);

            // Slide audio path
            trEl = document.createElement('tr');
            detailsEl.appendChild(trEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-label');
            tdEl.innerHTML = 'Slide ' + (i + 1) + ' audio path:';
            trEl.appendChild(tdEl);
            tdEl = document.createElement('td');
            tdEl.classList.add('detail-value');
            trEl.appendChild(tdEl);
            let slideAudioLink = document.createElement('a');
            slideAudioLink.href = URL.createObjectURL(slideAudioBlobs[i]);
            slideAudioLink.target = '_blank';
            slideAudioLink.classList.add('detail-link');
            slideAudioLink.innerHTML = slideAudioBlobs[i].name;
            tdEl.appendChild(slideAudioLink);
        }

        document.getElementById('openConfigButton').classList.add('hidden');
        document.getElementById('startShowButton').classList.remove('hidden');
        document.getElementById('closeConfigButton').classList.remove('hidden');

        // Preload all slide images to prevent lag time during slide show
        preloadSlideImages();

        configFound = true;
    } catch {
        configFound = false;
        //document.getElementById('config-error').classList.remove('hidden');
    }
}

/*
** Start the slide show
*/
export function startShow() {
    currentlyPlaying = true;
    document.getElementById('slide-show-container').style.display = 'block';
    document.getElementById('admin-console').style.display = 'none';

    let backImage = document.getElementById('slide-image-even');
    backImage.src = 'assets/black.png';
    let frontImage = document.getElementById('slide-image-odd');
    frontImage.src = 'assets/black.png';

    resizeTitleSlide();

    slideIndex = 0;
    context = 'fade-from-black';
    displaySlide();
}

/*
** Stop the slide show
*/
function stopShow() {
    currentlyPlaying = false;
    
    // Kill the intro music and previous audio clip if any
    stopIntroOutroMusic();
    stopPreviousAudio();

    clearTimeout(firstSlideTimer);
    clearTimeout(nextSlideTimer);

    document.getElementById('admin-console').style.display = 'grid';
    document.getElementById('slide-show-container').style.display = 'none';
}

/*
** Loop the background music if the presentation is still playing
*/
function restartBackgroundMusic() {
    if (currentlyPlaying) {
        introMusic = new Audio(URL.createObjectURL(backgroundMusicBlob));
        introMusic.addEventListener('ended', (e) => { restartBackgroundMusic() });
        introMusic.volume = backgroundMusicVolume;
        introMusic.play();
    }
}

/*
** Display the next slide
**
** This is a state machine driven by the context variable's value,
** following this pattern: intro -> slides -> outro -> fade-to-black
*/
function displaySlide() {
    // Stop the previous audio clip from running
    stopPreviousAudio()

    // Hide/show title slide content appropriately
    const titleSlideContent = document.getElementById('title-slide-content');
    if (context === 'intro') {
        setTimeout(() => {
            titleSlideContent.classList.add('title-slide-content-shown');
        }, 250);
    } else {
        titleSlideContent.classList.remove('title-slide-content-shown');
    }

    console.log('displaySlide, context=' + context + ', slideIndex=' + slideIndex);

    if (context === 'fade-from-black') {
        // Display initial black screen for a couple seconds
        setTimeout(() => {
            context = 'intro';
            displaySlide();
        }, fadeFromBlackSeconds * 1000);
    } else if (context === 'intro') {

        // Grab the previous image: the black screen
        let backImage = document.getElementById('slide-image-even');
        backImage.src = 'assets/black.png';
        backImage.style.zIndex = 1;

        // Set up the next image: the title screen
        let frontImage = document.getElementById('slide-image-odd');
        frontImage.src = 'assets/title.png';
        frontImage.style.zIndex = 0;

        console.log('End of intro slide processing')

        // Do a fade transition between the previous and next images
        setTimeout(() => {
            frontImage.classList.add('slide-shown');
            backImage.classList.remove('slide-shown');
        }, 100);

        if (musicApproach == 'background') {
            // Set up the background music
            introMusic = new Audio(URL.createObjectURL(backgroundMusicBlob));
            introMusic.addEventListener('ended', (e) => { restartBackgroundMusic() });
            introMusic.volume = backgroundMusicVolume;
        } else {
            // Set up the intro music. This music lasts a little longer than
            // the 7-second timer below, but this lets the intro music bleed
            // into the first slide's image and audio, resulting in a more
            // professionally blended experience.
            introMusic = new Audio(URL.createObjectURL(introMusicBlob));
            introMusic.volume = introMusicVolume;
        }
        introMusic.play();
        firstSlideTimer = setTimeout(() => {
            context = 'slides';
            slideIndex = 0;
            displaySlide();
        }, introSeconds * 1000);
    } else if (context === 'outro') {
        // Grab the previous image: the last slide from the show
        const backImage = document.getElementById('slide-image-' + (slideshowLength % 2 == 0 ? 'odd' : 'even'));
        backImage.style.zIndex = 0;

        // Set up the next image: the outro "jack henry" image
        const frontImage = document.getElementById('slide-image-' + (slideshowLength % 2 == 0 ? 'even' : 'odd'));
        frontImage.src = 'assets/jackhenry.png';
        frontImage.style.zIndex = 1;

        // Fade in the new slide's image first
        setTimeout(() => {
            frontImage.classList.add('slide-shown');
        }, 10);

        // Then fade out the old slide's image, *after* the 750ms fade-in for the new slide
        setTimeout(() => {
            backImage.classList.remove('slide-shown');
        }, 799);

        if (musicApproach == 'background') {
            fadeOutBackgroundMusic();
        } else {
            // Play outro music. This music lasts longer than the 5-second timer below,
            // but this lets the outro music bleed into the final black image,
            // resulting in a more professionally blended experience.
            outroMusic = new Audio(URL.createObjectURL(outroMusicBlob));
            outroMusic.volume = outroMusicVolume;
            outroMusic.play();
        }

        firstSlideTimer = setTimeout(() => {
            context = 'fade-to-black';
            displaySlide();
        }, outroSeconds * 1000);
    } else if (context === 'fade-to-black') {
        // Grab the previous image: the outro "jack henry" image
        const backImage = document.getElementById('slide-image-' + (slideshowLength % 2 == 0 ? 'even' : 'odd'));

        // Set up the next image: the black image
        const frontImage = document.getElementById('slide-image-' + (slideshowLength % 2 == 0 ? 'odd' : 'even'));
        frontImage.src = 'assets/black.png';

        // Do a fade transition between the previous and next images
        setTimeout(() => {
            frontImage.classList.add('slide-shown');
            backImage.classList.remove('slide-shown');
        }, 10);

        setTimeout(() => {
            // Finally, stop the show after the outro music has had time to play out
            stopShow();
        }, fadeToBlackSeconds * 1000);
    } else if (slideIndex < 0 || slideIndex >= slideshowLength) {
        // Ran off the beginning or end of the slide show, so stop
        stopShow();
    } else {
        // Grab the previous slide's image
        const backImage = document.getElementById('slide-image-' + (slideIndex % 2 == 0 ? 'odd' : 'even'));
        backImage.style.zIndex = 0;

        // Set up the next slide's image
        const frontImage = document.getElementById('slide-image-' + (slideIndex % 2 == 0 ? 'even' : 'odd'));
        frontImage.src = URL.createObjectURL(slideImageBlobs[slideIndex]);
        frontImage.style.zIndex = 1;

        // Fade in the new slide's image first
        setTimeout(() => {
            frontImage.classList.add('slide-shown');
        }, 10);

        // Then fade out the old slide's image, *after* the 750ms fade-in for the new slide
        setTimeout(() => {
            backImage.classList.remove('slide-shown');
        }, 799);

        // Slide audio handling
        if (!slideAudioBlobs[slideIndex]) {
            // If there is no audio for this slide, just move on to the next slide
            moveToNextSlide();
        } else {
            // Otherwise play the audio for this slide
            audio = new Audio(URL.createObjectURL(slideAudioBlobs[slideIndex]));
            audio.addEventListener('ended', (e) => { moveToNextSlide() });
            audio.play();
        }
    }
}

/*
** Preload all slide images to prevent lag time during slide show
*/
function preloadSlideImages() {
    for (let i = 0; i < slideshowLength; i++) {
        let img = new Image();
        img.src = URL.createObjectURL(slideImageBlobs[slideIndex]);
    }
}

/*
** Handle window keyDown event
*/
function keyDown(e) {
    if (e.key == 'Escape') {
        // Escape stops the slide show at any time
        stopShow();
    } else if (e.key == 'ArrowLeft') {
        // Left arrow moves to previous slide, but only within the slides context
        if (context === 'slides') {
            slideIndex--;
            if (slideIndex < 0) {
                slideIndex = 0;
            }
            displaySlide();
        }
    } else if (e.key == 'ArrowRight') {
        // Right arrow moves to next slide, but only within the slides context
        if (context === 'slides') {
            slideIndex++;
            if (slideIndex >= slideshowLength - 1) {
                slideIndex = slideshowLength - 1;
            }
            displaySlide();
        }
    }
}

/*
** Handle window resize event
*/
function resize(e) {
    resizeTitleSlide();
}

/*
** Resize the title slide as a fraction of the window width
*/
function resizeTitleSlide() {
    const scaleFactor = window.innerWidth / 1920;
    const el = document.getElementById('title-slide-content');
    if (el) {
        el.style.transform = 'scale(' + scaleFactor + '';
    }
}

/*
** Swing easing function
*/
function swing(p) {
    return 0.5 - Math.cos(p * Math.PI) / 2;
}

/*
** Fade out the background music at the end of the presentation
*/
async function fadeOutBackgroundMusic() {
    let duration = 6000;
    let interval = 13;
    const originalVolume = introMusic.volume;
    const delta = -originalVolume;

    if (!delta) {
        introMusic.volume = 0;
        return Promise.resolve();
    }

    const ticks = Math.floor(duration / interval);
    let tick = 1;

    return new Promise(resolve => {
        const timer = setInterval(() => {
            introMusic.volume = originalVolume + (
                swing(tick / ticks) * delta
            );

            if (++tick === ticks + 1) {
                clearInterval(timer);
                resolve();
            }
        }, interval);
    });
}

/*
** Stop the intro and outro music clips if any
*/
function stopIntroOutroMusic() {
    if (introMusic) {
        introMusic.pause();
        introMusic.currentTime = 0;
        introMusic = null;
    }
    if (outroMusic) {
        outroMusic.pause();
        outroMusic.currentTime = 0;
        outroMusic = null;
    }
}

/*
** Stop the previous audio clip if any
*/
function stopPreviousAudio() {
    if (audio) {
        audio.pause();
        audio.currentTime = 0;
        audio.removeEventListener('ended', (e) => { moveToNextSlide() });
        audio = null;
    }
}

/*
** Move to the next slide after the current slide's audio clip completes
*/
function moveToNextSlide() {
    nextSlideTimer = setTimeout(() => {
        slideIndex++;
        if (slideIndex >= slideshowLength) {
            context = 'outro';
        }
        displaySlide();
    }, 1000);
}

/*
** Process each slideshow file as a blob
*/
async function processDirectoryBlob(blob) {
    if (blob.name === 'config.json') {
        configFileData = await blob.text();
    } else if (blob.name.startsWith('music-background.')) {
        backgroundMusicBlob = blob;
    } else if (blob.name.startsWith('music-intro.')) {
        introMusicBlob = blob;
    } else if (blob.name.startsWith('music-outro.')) {
        outroMusicBlob = blob;
    } else if (blob.name.startsWith('title-image.')) {
        presentationTitleImageBlob = blob;
    } else if (blob.name.startsWith('slide-audio-')) {
        let done = false;
        let slideNumText = '';
        for (let i = ('slide-audio-').length; i < blob.name.length && !done; i++) {
            if ('0123456789'.includes(blob.name[i])) {
                slideNumText += blob.name[i];
            } else {
                done = true;
            }
        }
        let slideIndex = Number(slideNumText);
        while (slideIndex > slideAudioBlobs.length) {
            slideAudioBlobs.push(null);
        }
        slideAudioBlobs[slideIndex - 1] = blob;
    } else if (blob.name.startsWith('slide-image-')) {
        let done = false;
        let slideNumText = '';
        for (let i = ('slide-audio-').length; i < blob.name.length && !done; i++) {
            if ('0123456789'.includes(blob.name[i])) {
                slideNumText += blob.name[i];
            } else {
                done = true;
            }
        }
        let slideIndex = Number(slideNumText);
        while (slideIndex > slideImageBlobs.length) {
            slideImageBlobs.push(null);
        }
        slideImageBlobs[slideIndex - 1] = blob;
    }

    // Remember the folder name
    if (!presentationFolderName) {
        presentationFolderName = blob.directoryHandle.name;
    }
}

/*
** Initialize app
*/
function init() {
    // Display the current version number
    document.getElementById('version-number').innerText = 'Version ' + jhVidsBuilderVersion;

    // Let the user know if their browser doesn't support the browsder-fs-access functionality needed by this app
    if (!supported) {
        document.getElementById('browser-error').classList.remove('hidden');
        document.querySelector('.admin-buttons').classList.add('hidden');
    }

    // Wire up event handlers
    window.addEventListener('resize', (e) => resize(e));
    window.addEventListener('keydown', (e) => keyDown(e));
    document.getElementById('openConfigButton').addEventListener('click', async (e) => {
        try {
            const blobs = await directoryOpen();
            blobs
                .sort((a, b) => a.name.localeCompare(b))
                .forEach((blob) => {
                    processDirectoryBlob(blob);
                });
                setTimeout(() => { processSlideshowData(); }, 1000);
            ;
        } catch (err) {
            if (err.name !== 'AbortError') {
                return console.error(err);
            }
            console.log('The user aborted a request.');
        }
    });
    document.getElementById('startShowButton').addEventListener('click', (e) => startShow());
    document.getElementById('closeConfigButton').addEventListener('click', (e) => closeConfig());
}

/*
** Initialization starts after all DOM content is loaded
*/
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, false);
} else {
    init();
}
